import { useCallback } from 'react';
import { SOCKET_EVENTS } from '../constants/socketEvents';
import { useAuth } from '../contexts/AuthContext';
import { useSocket } from '../contexts/SocketProvider';
import { parsePartnerTemporaryDisableSocket } from '../utils/parsePartnerTemporaryDisableSocket';
import { useSocketEvent } from './useSocketEvent';

export const usePartnerTemporaryDisableSocketListener = ({ enabled = true } = {}) => {
  const { isPartner, updatePartnerProfile } = useAuth();
  const { isConnected } = useSocket();
  const canListen = Boolean(isPartner);

  const handleTemporaryDisableUpdated = useCallback(
    (envelope) => {
      if (!canListen) return;

      const parsed = parsePartnerTemporaryDisableSocket(envelope);
      if (!parsed) return;

      updatePartnerProfile((prev) => {
        if (!prev) return prev;
        return {
          ...prev,
          temporaryDisable: parsed.temporaryDisable,
          partnerProfile:
            prev.partnerProfile && typeof prev.partnerProfile === 'object'
              ? { ...prev.partnerProfile, temporaryDisable: parsed.temporaryDisable }
              : prev.partnerProfile,
        };
      });
    },
    [canListen, updatePartnerProfile],
  );

  useSocketEvent(
    SOCKET_EVENTS.PARTNER_TEMPORARY_DISABLE_UPDATED,
    enabled && canListen && isConnected ? handleTemporaryDisableUpdated : null,
    [enabled, canListen, isConnected, handleTemporaryDisableUpdated],
  );
};

export default usePartnerTemporaryDisableSocketListener;
